import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-lazy-loading-uploads/jb-lazy-loading-uploads.css.ts
var jb_lazy_loading_uploads_css_default = i`:host{display:block;width:100%}slot{display:grid;row-gap:11px}`;

export {
  jb_lazy_loading_uploads_css_default
};
